import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M10.906 23.012 16 19.467l5.094 3.545-1.797-5.94 4.945-3.75-6.204-.127L16 7.333l-2.038 5.862-6.205.127 4.946 3.75zm7.801-3.286L16 17.842l-2.707 1.884.955-3.157-2.628-1.992 3.297-.067L16 11.394l1.083 3.116 3.297.067-2.628 1.992z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M12.703 17.071 16 19.467l3.297-2.396-1.26-3.876h-4.074zm4.366-2.542.66 2.033L16 17.819l-1.73-1.257.661-2.033z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMar = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMar_default = SvgFlagMar;

export { FlagMar_default as default };
